export default {
  required: 'Field is required!',
};
